// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3wu11","avatar":"style_avatar__3WBi9"};